<template>
  <div class="row">
    <div class="col-md-6">
      <card>
        <template slot="header">
          <h4 class="card-title">Import Bag No. to HAWB</h4>
        </template>
        <el-form ref="form" :model="form" label-width="140px">
          <el-form-item label="File">
              <el-upload
                class="upload-demo"
                ref="upload"
                accept=".xlsx"
                :headers="uploadHeaders"
                :data="form"
                :action="uploadURI"
                :auto-upload="false"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :before-upload="beforeUpload"
              >
                <p-button
                  slot="trigger"
                  size="small"
                  type="primary"
                >select file</p-button>
                <div class="el-upload__tip" slot="tip">xlsx file.</div>
              </el-upload>
          </el-form-item>


          <el-form-item label="Description">
            <el-input
              type="textarea"
              autosize
              placeholder="Description"
              v-model="form.description">
            </el-input>
          </el-form-item>

          <el-form-item>
              <el-button type="danger">
                <a target="_blank" href="https://static.smoothexpress.com/template/SKL-Express_Import_Bag_No_v01.xlsx" rel="noopener">
                  Template
                </a>
              </el-button>
                <p-button
                  style="margin-left: 10px;"
                  size="small"
                  type="success"
                  @click="submitUpload"
                >upload to server</p-button>
          </el-form-item>
        </el-form>
      </card>
    </div>
  </div>
</template>


<script>
import Vue from "vue"
import * as _apiParcel from "@/api/parcel"
import * as _apiMAWB from "@/api/mawb"
import { Card } from
"src/components/UIComponents"
import {
  Upload,
  Loading,
  Table,
  TableColumn,
  Select,
  Option,
  Tabs,
  TabPane,
  Button,
  Tooltip,
  Form,
  FormItem,
  Input,
  Checkbox,
  Notification,
  DatePicker,
  Tag,
  Scrollbar,
  Row,
  Col,
} from "element-ui"
import PPagination from "src/components/UIComponents/Pagination.vue"
Vue.use(Loading)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Tag)
Vue.use(Scrollbar)
Vue.use(Row)
Vue.use(Col)


export default {
    components: {
    PPagination,
    Card,
    Notification,
    [Upload.name]: Upload,
    },
  data() {
    return {
      form: {
        description: '',
      },
      uploadHeaders: {
        Authorization: ''
      },
      uploadURI: '',
      loading: {}
    }
  },
  mounted () {
    this.uploadURI = process.env.VUE_APP_ROOT_API || 'http://127.0.0.1:5005';
    this.uploadURI = this.uploadURI + '/api/w/import/update_bagno'
  },
  methods: {
    reset () {
      this.form.description = ''
      this.$validator.reset()
    },
    handleUploadSuccess(response, file, fileList) {
      this.closeWrapperFullScreen()
      alert('Uploaded Successfully')
    },
    handleUploadError(err, file, fileList) {
      this.closeWrapperFullScreen()
      alert('Unsuccessfully,' + JSON.parse(err.message).message)
    },
    beforeUpload(file) {
      let token = localStorage.getItem('token')
      this.uploadHeaders.Authorization = "Bearer " + token
      this.openWrapperFullScreen()
      return true;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    openWrapperFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      });
    },
    closeWrapperFullScreen() {
      this.loading.close()
    }
  }
}
</script>
